﻿import {Random} from "./Unity/Random";
import {PlayerPrefs} from "./Unity/PlayerPrefs";

export class Utils {
    static StringsToInts(strings) {
        let ints = [];
        for (let i = 0; i < strings.length; i++) {
            ints[i] = parseInt(strings[i]) || 0; // int.Parse
        }
        return ints;
    }

    static StringsToShorts(strings) {
        let ints = [];
        for (let i = 0; i < strings.length; i++) {
            ints[i] = ~~strings[i]; // short.Parse
        }
        return ints;
    }

    static IntsToString(ints) {
        return [...ints].join(",");
    }

    static CheckPlanarDistance(x1, y1, x2, y2, distance) {
        return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2) < distance * distance;
    }

    //    static CheckPlanarDistance(p1, p2, distance) {
    //        return this.CheckPlanarDistance(p1.x, p1.z, p2.x, p2.z, distance);
    //    }
    //

    static CheckPlanarDistanceXY(p1, p2, distance) {
        return this.CheckPlanarDistance(p1.x, p1.y, p2.x, p2.y, distance);
    }

    static GetPlanarDistance(x1, y1, x2, y2) {
        return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
    }

    //    static GetPlanarDistance(p1, p2) {
    //        return this.GetPlanarDistance(p1.x, p1.z, p2.x, p2.z);
    //    }

    static scaleBetween(unscaledNum, minAllowed, maxAllowed, min, max) {
        return ((maxAllowed - minAllowed) * (unscaledNum - min)) / (max - min) + minAllowed;
    }

    static DayId(date) {
        if (Number.isInteger(date)) {
            date = new Date(date);
        }
        // return long.Parse(date.Year + "" + date.Month + "" + date.DayOfYear);
        return ~~("" + date.getFullYear() + date.getMonth() + date.getDate());
    }

    static Format(str, ...args) {
        for (let i = 0; i < args.length; i++) {
            let reg = new RegExp(`\\{${i}\\}`, "g");
            str = str.replace(reg, args[i]);
        }

        let reg = /{(\d+)}/g;
        let missed = str.match(reg);
        if (missed) {
            console.warn(`STRING missing parameters for '${str}'`);
            // translation = translation.replace(reg, "");
        }
        return str;
    }
}

export class WeightedRandomization {
    // public static T Choose<T>(List<T> list) where T : IWeighted
    static Choose(list) {
        if (list.length < 2) return list[0];
        let totalWeight = list.reduce((res, item) => res + item.GetWeight(), 0);
        let choice = Random.Range(0, totalWeight);
        let sum = 0;
        for (let obj of list) {
            for (let i = sum; i < obj.GetWeight() + sum; i++) {
                if (i >= choice) return obj;
            }
            sum += obj.GetWeight();
        }
        return list[0];
    }

    // public static T ChooseReverse<T>(List<T> list) where T : IWeighted
    static ChooseReverse(list) {
        if (list.length < 2) return list[0];

        let max = Math.max(...list.map(item => item.GetWeight()));
        for (let item of list) {
            item.ReverseWeight = max - item.GetWeight();
        }

        let totalweight = list.reduce((res, item) => res + item.ReverseWeight, 0);
        let choice = Random.Range(0, totalweight);
        let sum = 0;

        for (let obj of list) {
            for (let i = sum; i < obj.ReverseWeight + sum; i++) {
                if (i >= choice) return obj;
            }
            sum += obj.ReverseWeight;
        }
    }
}

if (__SOCIAL__ === "fb") {
    PlayerPrefs.Load();
}
